// Courier configuration. Prices are in EUR.
// SK = within Slovakia, EU = anywhere else (rest of EU).
// Free shipping threshold (in cart EUR subtotal) applies after coupon discount.
export const FREE_SHIPPING_THRESHOLD_EUR = 1000;

export const COURIERS = [
  { id: 'gls', name: 'GLS', price_sk: 4.0, price_eu: 12.0, eta_sk: '1-2', eta_eu: '3-5' },
  { id: 'dpd', name: 'DPD', price_sk: 4.5, price_eu: 14.0, eta_sk: '1-2', eta_eu: '3-5' },
  { id: 'dhl', name: 'DHL', price_sk: 6.0, price_eu: 15.0, eta_sk: '1-2', eta_eu: '2-4' },
  { id: 'ups', name: 'UPS', price_sk: 7.0, price_eu: 18.0, eta_sk: '1-2', eta_eu: '2-4' },
];

const SK_NAMES = ['Slovakia', 'Slovensko', 'SK'];

export const isSlovakia = (country) => SK_NAMES.includes((country || '').trim());

export const getCourierPrice = (courierId, country, cartTotalEur) => {
  const c = COURIERS.find((x) => x.id === courierId);
  if (!c) return 0;
  if (cartTotalEur >= FREE_SHIPPING_THRESHOLD_EUR) return 0;
  return isSlovakia(country) ? c.price_sk : c.price_eu;
};

export const getCourierEta = (courierId, country) => {
  const c = COURIERS.find((x) => x.id === courierId);
  if (!c) return '';
  return isSlovakia(country) ? c.eta_sk : c.eta_eu;
};
